<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    //- filter-success-rate.mr-2(ref="success" :filter.sync="successFilter" check-initial-value)
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterSuccessRate from '@/components/clinic/marketing/filters/FilterSuccessRate.vue'

export default {
  components: { FilterName, FilterSuccessRate },
  props: ['filters', 'propFilters'],
  data: () => ({
    key: 0,
    nameFilter: {},
    successFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.successFilter.key) {
        filters.push(this.successFilter)
      }

      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        successFilter: this.successFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.successFilter = this.propFilters?.successFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.success.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.successFilter = {}
    },
  }
}
</script>